import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

import { environment } from '@env/environment';
import { CoreModule, HttpService } from '@app/core';
import { RouterModule, Routes } from '../../node_modules/@angular/router';
import { AppComponent } from './app.component';

import { AuthGuard } from '@app/auth.guard';
import { AuthService } from '@app/auth.service';

import { UserService } from '@app/user.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';

import { RegisterComponent } from './member/register/register.component';
import { UtilService } from './utility/util.service';
import { MasterService } from './utility/master.service';
import { ApiService } from './utility/api.service';
import { HomeComponent } from './home/home/home.component';
import { NoCacheHeadersInterceptorService } from '@app/no-cache-headers-interceptor.service'


import { MemberImportComponent } from './member/member-import/member-import.component';
import { MemberAcountPermisstionComponent } from './member/member-acount-permisstion/member-acount-permisstion.component';
import { MembertypeComponent } from './member/membertype/membertype.component';
import { PositionComponent } from './member/position/position.component';
import { DepartmentComponent } from './member/department/department.component';
import { positionElements } from '@ng-bootstrap/ng-bootstrap/util/positioning';

import { CreateQrcodeComponent } from './member/create-qrcode/create-qrcode.component';

import { ProfileComponent } from './profile/profile.component';
import { ContactReportComponent } from './contact-report/contact-report.component';
import { DetailComponent } from './detail/detail.component';
import { ProfileRegisterComponent } from './profile-register/profile-register.component';
import { TicketListComponent } from './ticket/ticket-list/ticket-list.component';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { CryptographyService } from '@app/cryptography.service';
import { ReqDocumentComponent } from './req-document/req-document.component'
import { PreReqDocumentComponent } from './pre-req-document/pre-req-document.component'


const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'mainmenu', component: MainmenuComponent/*, canActivate: [AuthGuard]*/,
    children: [



      { path: 'home', component: HomeComponent/*, canActivate: [AuthGuard]*/ },

      //Member
      { path: 'member-register', component: RegisterComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-import', component: MemberImportComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-membertype', component: MembertypeComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-position', component: PositionComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-department', component: DepartmentComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-create-qrcode', component: CreateQrcodeComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'member-account-permisstion', component: MemberAcountPermisstionComponent/*, canActivate: [AuthGuard]*/ },

      { path: 'contactReport', component: ContactReportComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'profile', component: ProfileComponent/*, canActivate: [AuthGuard]*/ },
      { path: 'register', component: ProfileRegisterComponent/*, canActivate: [AuthGuard]*/ },    
      { path: 'ticketlist', component: TicketListComponent/*, canActivate: [AuthGuard]*/ },  
      { path: 'reqdocument', component: ReqDocumentComponent/*, canActivate: [AuthGuard]*/ },    
      { path: 'prereqdocument', component: PreReqDocumentComponent/*, canActivate: [AuthGuard]*/ },  
    ]
  }
];

@NgModule({
  imports: [
    BrowserModule, 
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    HttpClientModule,
    HttpModule,
    TranslateModule.forRoot(),
    CoreModule,
    ReactiveFormsModule,
    RouterModule.forRoot(
      appRoutes
    )
  ],
  declarations: [AppComponent,
    LoginComponent,
    MainmenuComponent,
    RegisterComponent,
    HomeComponent,
    MemberImportComponent,
    MembertypeComponent,
    PositionComponent,
    DepartmentComponent,
    CreateQrcodeComponent,
    MemberAcountPermisstionComponent,
    ProfileComponent,
    ContactReportComponent,
    DetailComponent,
    ProfileRegisterComponent,
    TicketListComponent,
    ResetPasswordComponent,
    ReqDocumentComponent,
    PreReqDocumentComponent,
  ],
  providers: [
    AuthService, 
    UtilService, 
    MasterService, 
    AuthGuard, 
    UserService, 
    ApiService, 
    CryptographyService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts